import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Force cleanup of broken ServiceWorkers on first load
const cleanupBrokenSW = async () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  
  try {
    // Check if we're in a potential SW loop
    const lastAttempt = sessionStorage.getItem('sw-cleanup-attempt');
    const now = Date.now();
    
    // If page is loading fresh (not from session storage cleanup), check for issues
    if (!lastAttempt) {
      sessionStorage.setItem('sw-cleanup-attempt', now.toString());
      
      // Give the page 5 seconds to load, if we're still here after that, SW might be broken
      setTimeout(async () => {
        // If we reach this point and content hasn't loaded, clean up SW
        const contentLoaded = document.querySelector('[data-app-loaded]');
        if (!contentLoaded) {
          console.log('🧹 App did not load in time, cleaning up ServiceWorker...');
          
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map(reg => reg.unregister()));
          
          if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(name => caches.delete(name)));
          }
          
          sessionStorage.setItem('sw-cleanup-attempt', 'done');
          window.location.reload();
        }
      }, 5000);
    }
  } catch (e) {
    console.warn('SW cleanup failed:', e);
  }
};

// Run cleanup in production
if (!import.meta.env.DEV) {
  cleanupBrokenSW();
}

// Désactive le service worker en mode développement pour éviter les problèmes de cache en preview
if (import.meta.env.DEV && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().catch((error) => {
        console.warn('[PWA] Échec de la désinscription du service worker en dev', error)
      })
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

